import { Injectable } from '@angular/core';
import { HttpHelper } from 'nglhelper';
import { AuthService } from '../../common/services/authservice';

@Injectable()
export class ActionProviderService {
    isInit = false;
    fullProcessAction: any;

    constructor(
        private auth: AuthService,
        private http: HttpHelper) {
        }

    async initActionService(){
        this.fullProcessAction = await this.http.Get('/api/process/full');

        this.isInit = true;
    }
    

    getActions(assetRecord, aclRightVal) {
        //console.log("aclRightVal:" + aclRightVal);
        if(this.fullProcessAction){
            var matchProcess = this.fullProcessAction.Process.find(r => {
                return r.AssetTypeId == assetRecord.TypeId;
            });
            
            if(matchProcess){
                var matchProcessId = matchProcess.Id;

                if(aclRightVal == 30)
                {
                    var fullActs = this.fullProcessAction.Steps.filter(r => {
                        return (r.ProcessId == matchProcessId); // && r.ActionId != assetRecord.Status    //only return matching processId & actions which are not current status
                    });

                    return fullActs;
                }
                else{
                    var currStep = this.fullProcessAction.Steps.find(r => {
                        return (r.ActionId == assetRecord.Status && r.ProcessId == matchProcessId);
                    });

                    var nextActionIds =  currStep.Properties.NextAction;
                    if(nextActionIds.length > 0)
                    {
                        let arrNextAction = [];
                        for(var i=0;i<nextActionIds.length;i++)
                        {
                            var act = this.fullProcessAction.Steps.find(r => {
                                return (r.ActionId == nextActionIds[i] && r.ProcessId == matchProcessId);
                            });

                            if(act)
                            {
                                if (act.hasOwnProperty("AuthCompany")) 
                                {
                                    var authCompanies = act.AuthCompany;
                                    if(authCompanies)
                                    {
                                        if(authCompanies.indexOf(this.auth.User.CompanyId) > -1 || this.auth.IsSysadmin())   //for next step auth company check
                                        {
                                            arrNextAction.push(act);
                                        }
                                    }
                                }
                            }
                        }

                        return arrNextAction;
                    }
                    else{
                        return [];
                    }
                }
       
            }
            else{
                return [];
            }
        }

        //filter based on authorized company
        //return 
        //return matchProcess["Steps"];
    }
}
